module.exports = {
    namespace: 'layout',

    da: {
        footer: {
            newsletter: {
                title: 'Nyhedsbrev',
                text: 'Ønsker du gode råd til at øge bundlinjen?',
                success: 'Du er nu skrevet op til vores nyhedsbrev!',
                error: 'Vi kunne ikke skrive dig op, prøv venligst igen.',
            },
            skills: {
                title: 'Populære Opgavetyper',
            },
            pages: {
                title: 'Taskflex',
            },
        },
    },

    en: {
    },
};



// WEBPACK FOOTER //
// ./src/global/locales/layout.js